import { MessageBarGroup } from '@fluentui/react-components';
import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { CustomMessageBar } from '../components/messagebar/customMessageBar';

/** App-owned feedback intent (replaces Fluent 8 MessageBarType for toasts). */
export type FeedbackMessageIntent = 'error' | 'success' | 'warning' | 'info';

export interface IFeedbackMessageContextValues {
    displayFeedbackMessage: (message: IFeedbackMessage) => void;
    activeMessage: IFeedbackMessage | undefined;
    clearActiveMessage: () => void;
}

export interface IFeedbackMessage {
    message: string | React.ReactNode;
    type: FeedbackMessageIntent;
}
export const FeedbackMessagesContext = createContext<IFeedbackMessageContextValues | null>(null);

export function FeedbackMessagesContextProvider(props: { value?: IFeedbackMessageContextValues; children?: React.ReactNode }) {
    const [activeMessage, setActiveMessage] = useState<IFeedbackMessage | undefined>(undefined);
    const clearActiveMessage = () => setActiveMessage(undefined);
    const location = useLocation();

    useEffect(() => {
        clearActiveMessage();
    }, [location.pathname]);

    const contextValue = props.value ?? {
        displayFeedbackMessage: setActiveMessage,
        activeMessage,
        clearActiveMessage,
    };

    return (
        <FeedbackMessagesContext.Provider value={contextValue}>
            {activeMessage && (
                <MessageBarGroup>
                    <CustomMessageBar message={activeMessage.message} type={activeMessage.type} setActiveMessage={setActiveMessage} />
                </MessageBarGroup>
            )}
            {props.children}
        </FeedbackMessagesContext.Provider>
    );
}
